import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { Crash } from "./Crash";
import { installEnvMarker } from "./env";
import { installFillColours } from "./fill";
import { watchInstall } from "./offline/install";
import { onBeforeReload, startUpdates } from "./offline/update";
import { UpdateNote } from "./offline/UpdateNote";
import { flush as flushCache } from "./store/store";
import "./styles.css";
import { watchTheme } from "./theme";

installEnvMarker();
watchTheme();
installFillColours();
watchInstall();
onBeforeReload(flushCache);
if (import.meta.env.PROD) startUpdates();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Crash>
      <App />
      <UpdateNote />
    </Crash>
  </StrictMode>,
);
